<template lang='pug'>
.main-container

  .view-content
    el-card
      div(slot='header')
        i.mat-icon credit_card
        | Payment methods
        el-button(type="primary", @click="addNewCard", style='float: right')
          i.mat-icon add_circle
          | Add card
      el-table(:data='cards', v-loading='cards == null')
        el-table-column(prop='name', label='Card')
          template(slot-scope='scope')
            | {{scope.row.name}}
        el-table-column(prop='expiration', label='Expiration')
          template(slot-scope='scope')
            | {{scope.row.expiration}}
        el-table-column(label='Actions')
          template(slot-scope='scope', v-if='scope.row.id != "OFFLINE"')
            el-button(type='text' size='small', @click='deleteCardDialog(scope.row, scope.$index)') Delete

    el-card
      div(slot='header')
        i.mat-icon receipt
        | Invoices
      el-row(:gutter='10')
        el-col(:span='9')
          el-input(v-model='sorting' prefix-icon="el-icon-search" placeholder="Search" )
      el-table(:data='invoices', v-loading='invoices == null')
        el-table-column(prop='date', label='Date')
          template(slot-scope='scope')
            | {{ $formatDate(scope.row.delivery_date) }}
        el-table-column(prop='id', label='Invoice#' width='90')
        el-table-column(prop='people', label='People' width='90')
        el-table-column(prop='vendor_name', label='Vendor')
        el-table-column(prop='total', label='Total')
          template(slot-scope='scope')
            | {{ $formatCents(scope.row.total_cents) }}&nbsp;&nbsp;
            el-tag {{ formatStatus(scope.row.status) }}
        el-table-column(prop='total', label='Balance' width='90')
          template(slot-scope='scope')
            | {{ $formatCents(scope.row.balance_cents) }}&nbsp;&nbsp;
        el-table-column(prop='total', label='Actions')
          template(slot-scope='scope')
            el-button(type='text', @click='$openInBlank(`/print/invoices/${scope.row.id}`)')
              | View invoice &nbsp;
              span.mat-icon open_in_new
      el-col()
        el-pagination( 
          v-if="pagination.pages > 1"
          @current-change="onPaginationChange"
          :page-size="pagination.per_page", 
          :pager-count="pagination.pages", 
          layout="prev, pager, next", 
          :total="pagination.total") 
        
</template>

<script>
  import Toolbar from '../layout/Toolbar.vue'


    function data(){
      return {
        invoices: null,
        sorting: '',
        cards: null,
        loadingCards: true,
        loadingInvoices: true,
        pagination: {
          per_page: null,
          current: null,
          pages: null,
          total: null,
        }
      }
    }

    function onPaginationChange(current_page){
      this.getInvoices(current_page);
    }

    function getCards(){
      this.loadingCards = true
      return this.$simplecater.get('/cards').then((r)=> {
        this.cards = r.data.data
        this.loadingCards = false
      })
    }

    function getInvoices(current_page){
      this.loadingInvoices = true
      let reqParams = (current_page ?{params:{ page:current_page}}:{params:{}});
      if(this.sorting){
        this.$isNumber(this.sorting)?reqParams.params.id=this.sorting:reqParams.params.q=this.sorting
      }
      return this.$simplecater.get('/invoices',reqParams).then((r)=> {
        this.invoices = _.sortBy(r.data.data, 'created_at').reverse()
        // created_at
        this.loadingInvoices = false
        this.pagination = r.data.pagination;
      })
    }

    function addNewCard(){
      this.$checkout.open({
        name: 'Use your credit card',
        currency: 'USD',
        panelLabel: 'Save card',
        // amount: 9,
        billingAddress: false,
        allowRememberMe: false,
        token: (token) => {
          let data = {
            token: token.id
          }
          this.$simplecater.post('/cards', data).then((r)=> {
            this.getCards()
          })
        }
      })
    }

    function created(){
      this.getCards()
      this.getInvoices()
    }

    function formatUnixTimestamp(timestamp){
      const date = new Date(timestamp * 1000)
      return date.toLocaleDateString()
    }

    function deleteCardDialog ( card, idx ) {
      console.log('Delete', card)
      const title = "Delete Card"
      const msg = "Are you sure you want to delete this card?"
      this.$confirm(msg, title, {
        confirmButtonText: 'Yes, delete it',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        this.deleteCard(card)
      }).catch(() => { })
    }

    function deleteCard ( card, idx ) {
      this.$simplecater.delete('/cards/' + card.id).then( ( r )=> {
        let newCards = _.map(this.cards, _.id)
        newCards.splice(idx, 1)
        this.cards = newCards
        this.$message("The card was deleted")
      }).catch( ( err ) => {
        this.$message.error('This card cannot be deleted')
      })
    }

    function formatStatus(str) {
      if (str === 'PENDING_PAYMENT') return 'pending';
      return str.replace(/_/g,' ').toLowerCase();
    }

    const watch = {
      sorting: function(){
        this.getInvoices();
      },
      '$route' (to, from) {
        console.log("Reloading data")
        this.getCards()
        this.getInvoices()
      }
    }

    const components = { Toolbar }

    const methods = {
      getCards, onPaginationChange, getInvoices, addNewCard, formatUnixTimestamp, deleteCardDialog, deleteCard, formatStatus
    }

    export default { methods, components, data, created,watch }

</script>



// WEBPACK FOOTER //
// src/user/Billing.vue